import React from 'react';
import { TRY_MODE } from '../../../../common/Utils/Utils';

/**
 * CreditInfoSection Component
 *
 * Displays credit cost information for the product
 * Shows credits per execution and per page (if applicable)
 *
 * @param {Object} currentProduct - Product data containing weightage info
 * @param {string} mode - 'dual' or 'single' mode
 */
const CreditInfoSection = ({ currentProduct, mode }) => {
  return (
    <div
      className={`position-absolute creditremainingSection font_12 font_600 end-0 me-3 ${
        mode === TRY_MODE.DUAL ? 'bottom-0' : 'top_Min_16x'
      }`}
    >
      {currentProduct?.productWeightage ? (
        <>
          {currentProduct?.productWeightage && (
            <>{currentProduct.productWeightage} Credits per Execution </>
          )}
          {currentProduct.productName === 'Aadhaar Masking' && (
            <>
              {'&'}
              <> {currentProduct.pageWeightage || '0.15'} Credits per Page</>
            </>
          )}
        </>
      ) : (
        'N/A'
      )}
    </div>
  );
};

export default CreditInfoSection;
